module.exports = __webpack_public_path__ + "static/media/warning.e9644dc2.svg";